export default __webpack_public_path__ + "static/media/cloud1.deebc7b5.png";